import React from "react";
import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import { useSelector } from "react-redux";
import { getCaseColumns } from "./caseGridConfig";

const CaseGrid = ({caseId, statuses, taskTypes}) => {
    const tasks = useSelector(state => state.tasks.allTasks.filter(t => t.caseId == caseId));
    return (
        <>
            <DataGrid
                sx={{ width: 1 }}
                rows={tasks || {}}
                columns={getCaseColumns(statuses, taskTypes)}
                getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                }
                initialState={{
                pagination: { paginationModel: { pageSize: 20 } },
                }}
                pageSizeOptions={[10, 20, 50]}
                disableColumnResize
                density="compact"
                slotProps={{
                filterPanel: {
                    filterFormProps: {
                    logicOperatorInputProps: {
                        variant: "outlined",
                        size: "small",
                    },
                    columnInputProps: {
                        variant: "outlined",
                        size: "small",
                        sx: { mt: "auto" },
                    },
                    operatorInputProps: {
                        variant: "outlined",
                        size: "small",
                        sx: { mt: "auto" },
                    },
                    valueInputProps: {
                        InputComponentProps: {
                        variant: "outlined",
                        size: "small",
                        },
                    },
                    },
                },
                }}
            />
        </>
    );
}

export default CaseGrid;